module.exports = __webpack_public_path__ + "static/media/logo-dark.b4e7b05c.png";